// extracted by mini-css-extract-plugin
export default {"root":"Ne4s8T","holder":"GOGiOy","image":"qGLqQ7","imageTypeDesktop":"L3dw_3","imageTypeMobile":"E5zT9j"};